/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query HatchoverviewQuery($uid: String!) {
    prismic {
      hatchoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_HatchoverviewBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_HatchoverviewBodyCarouseltestimonial {
          type
            label
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading1
              subheading_color
            }
            fields {
              logo
              quote
              author
              author_details
              avatar
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_text
            }
        },
        ... on PRISMIC_HatchoverviewBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_HatchoverviewBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_HatchoverviewBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_HatchoverviewBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_HatchoverviewBodyQuote {
          type
            label
            primary {
              quote
              align_content
              author_details
              author_image
              author_name
              background_color
              background_image
              logo
              text_color
            }
        },
        ... on PRISMIC_HatchoverviewBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Hatchoverview = ({ data, location }) =>
  data.prismic.hatchoverview ? (
    <MainLayout location={location} layout='hatchoverview'>
    <Helmet>
      <title>{(data.prismic.hatchoverview.title[0] && data.prismic.hatchoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.hatchoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.hatchoverview.path : 'https://www.digitalocean.com' + data.prismic.hatchoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.hatchoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.hatchoverview.title[0] ? data.prismic.hatchoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.hatchoverview.description ? data.prismic.hatchoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.hatchoverview.open_graph_image ? data.prismic.hatchoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.hatchoverview.description ? data.prismic.hatchoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.hatchoverview.title[0] ? data.prismic.hatchoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.hatchoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.hatchoverview.path : 'https://www.digitalocean.com' + data.prismic.hatchoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.hatchoverview.open_graph_image ? data.prismic.hatchoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.hatchoverview.body} />
    </MainLayout>
  ) : null;

Hatchoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Hatchoverview;
